import { render, staticRenderFns } from "./tinkSlideItem.vue?vue&type=template&id=cf6818de&scoped=true"
import script from "./tinkSlideItem.vue?vue&type=script&lang=js"
export * from "./tinkSlideItem.vue?vue&type=script&lang=js"
import style0 from "./tinkSlideItem.vue?vue&type=style&index=0&id=cf6818de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6818de",
  null
  
)

export default component.exports